<div class="top-bar">
    <span>Bienvenido: <b>{{user.fullName}}</b></span> |
    <!--<a (click)="password()">Actualizar Contraseña</a> |-->
    <a (click)="logout()">Salir</a>
</div>